import React from 'react';

const LibraIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 70H90" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M20 60H80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M30 60L50 40L70 60" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default LibraIcon;
